export const getTaxSetting = state => {
    return state.props
}

export const isIndiaTax = state => {
    let taxList = state.props.filter((option) => {
        return option.gst_india === true
    })
    return taxList.length > 0
}


// WEBPACK FOOTER //
// ./src/store/modules/taxSetting/getters.js